'use client';

import Switch from 'react-switch';

import type { ReactSwitchProps as SwitchProps } from 'react-switch';

export { Switch };
export type { SwitchProps };
